/* eslint-disable use-isnan */
/* eslint-disable max-len */
import React from "react";
import "./style.scss";
import { QlikProvider } from "./context/Qlik";
import { FilterBarProvider } from "./context/FilterBar";
import { BookMarkProvider } from "./context/BookMarkContainer";
import { LeftBarProvider } from "./context/LeftBar";
import { ConfigProvider } from "./context/Config";
import Layout from "./pages/Layout";
import { FiltersProvider } from "./context/Filters";
import { ModalProvider } from "./context/Modal";
import { ExportIdProvider } from "./context/ExportId";
import { SelectionsProvider } from "./context/Selections";
import { setCookie } from "nookies";

function App() {
  const query = new URLSearchParams(window.location.search);
  if (query.get("u")) {
    setCookie(null, "userHash", query.get("u"), {
      path: "/",
      maxAge: 72576000,
      secure: true,
      domain: ".mtrix.com.br",
    });
  }
  const hash = window.location.hash.replace(/^#/, "");
  const defaultRoutes = ["/", "/overview"];
  if (!hash || defaultRoutes.includes(hash)) {
    window.location.hash = "/overview?segment=alimentar";
  }
  const config = {
    host: process.env.REACT_APP_HOST,
    prefix: process.env.REACT_APP_PREFIX || "/",
    port: Number(process.env.REACT_APP_PORT) || 443,
    isSecure: process.env.REACT_APP_IS_SECURE === "true",
  };

  return (
    <QlikProvider config={config}>
      <SelectionsProvider>
        <BookMarkProvider>
          <ModalProvider>
            <FilterBarProvider>
              <LeftBarProvider>
                <ConfigProvider>
                  <FiltersProvider>
                    <ExportIdProvider>
                      <Layout />
                    </ExportIdProvider>
                  </FiltersProvider>
                </ConfigProvider>
              </LeftBarProvider>
            </FilterBarProvider>
          </ModalProvider>
        </BookMarkProvider>
      </SelectionsProvider>
    </QlikProvider>
  );
}

export default App;
